const URL_DEPARTURE_SCHEDULES = "https://com-surpnorm-senseev.appspot.com/v1/departureSchedules";

class DepartureSchedulesApi {

  static requestHeaders(deviceId, authToken) {
    return {'Authorization': `Bearer deviceId="${deviceId}",authenticationToken="${authToken}"`}
  }

  static getDepartureSchedules(deviceId, authToken) {
    const headers = this.requestHeaders(deviceId, authToken);
    const request = new Request(`${URL_DEPARTURE_SCHEDULES}`, {
      method: 'GET',
      headers: headers
    });

    return fetch(request).then(response => {
		return response.json().then(json => {
			return json.items;
		});
    }).catch(error => {
      return error;
    });
  }
  
  static createDepartureSchedule(deviceId, authToken, departureSchedule) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_DEPARTURE_SCHEDULES}`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(departureSchedule)
    });

    return fetch(request).then(response => {
		return response.json();
    }).catch(error => {
      return error;
    });
  }

  static updateDepartureSchedule(deviceId, authToken, departureSchedule) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_DEPARTURE_SCHEDULES}/` + departureSchedule.id, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(departureSchedule)
    });

    return fetch(request).then(response => {
		return response.json();
    }).catch(error => {
      return error;
    });
  }

  static deleteDepartureSchedule(deviceId, authToken, departureSchedule) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_DEPARTURE_SCHEDULES}/` + departureSchedule.id, {
      method: 'DELETE',
      headers: headers
    });

    return fetch(request).then(response => {
		return response.json();
    }).catch(error => {
      return error;
    });
  }
}

export default DepartureSchedulesApi;


// WEBPACK FOOTER //
// ./src/api/departureSchedulesApi.js